import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { config } from '@/plugins/env.config'
import englishMessages from '@/locale/english'
import { spanishMessages, spanishDominicanMessages, spanishMexicanMessages } from '@/locale/spanish'
import portugueseMessages from '@/locale/portuguese'

const getDefaultLocale = (configLocale) => {
  const navigatorLocale = navigator.language || navigator.languages[0];
  
  if (navigatorLocale && navigatorLocale.includes('pt')) {
    return 'pt';
  }

  return configLocale;
}

const defaultLocale = getDefaultLocale(config.locale);

const messages = {
  'en': englishMessages,
  'es': spanishMessages,
  'es-DO': spanishDominicanMessages,
  'pt': portugueseMessages,
  'es-MX': spanishMexicanMessages,
}

const dateTimeFormats = {
  'en': {
    short: {
      year: '2-digit', month: '2-digit', day: '2-digit'
    },
    long: {
      year: '2-digit', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hour12: true
    }
  },
  'es': {
    short: {
      year: '2-digit', month: '2-digit', day: '2-digit'
    },
    long: {
      year: '2-digit', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hour12: true
    }
  },
  'es-DO': {
    short: {
      year: '2-digit', month: '2-digit', day: '2-digit'
    },
    long: {
      year: '2-digit', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hour12: true
    }
  },
  'pt': {
    short: {
      year: '2-digit', month: '2-digit', day: '2-digit'
    },
    long: {
      year: '2-digit', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hour12: true
    }
  },
}

Vue.use(VueI18n)

export default new VueI18n({
  locale: defaultLocale,
  fallbackLocale: 'es',
  messages,
  silentFallbackWarn: true,
  silentTranslationWarn: true,
  dateTimeFormats
})
